import React from 'react';
import NavAdmin from '../../nav-admin/nav-admin';


const HeaderNotify = () => (
    <header className="HeaderNotify" role="banner">
        <nav className="navbar navbar-expand-sm navbar-toggleable-sm box-shadow admin-custom-navbar" aria-label="Notify application header bar with admin navigation">
            <div className="container w-max2">
                <h5 className="sp-mx" id="notify-header-title">
                    <i className="bi bi-bell" aria-hidden="true"></i>
                    <span className="spacer-margin2 v-set4" >NOTIFY</span>
                </h5>
                <NavAdmin />
            </div>
        </nav>
    </header>
);

export default HeaderNotify;